import { render, staticRenderFns } from "./RegistrationForOnDemand.vue?vue&type=template&id=769e6037&scoped=true&"
import script from "./RegistrationForOnDemand.vue?vue&type=script&lang=js&"
export * from "./RegistrationForOnDemand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769e6037",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})
